import BaseService from "@/services/Base-service";

class CompanySectionService {
  get controllerName() { return '/CompanySection/'; }

  getListCompanyReferralBases(sectionId, customerId){
    return BaseService.get(this.controllerName + 'GetListCompanyReferralBases', {sectionId, customerId});
  }

  godifyRangeCompanyReferralBases(model){
    return BaseService.post(this.controllerName + 'ModifyRangeCompanyReferralBases', model);
  }
}

export default new CompanySectionService();
